import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "../../data/content";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 2.4, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-gold/15" : "bg-transparent"
      }`}
    >
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3 group">
          <img src="/mc-logo.png" alt="Ms Chancellor Entertainment" className="h-11 w-11 object-contain" />
          <span className="hidden sm:block font-serif text-lg leading-none tracking-wide">
            <span className="text-gold">Ms Chancellor</span>
            <span className="block text-[10px] tracking-[0.4em] uppercase text-white/50 mt-1">Entertainment</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-[13px] uppercase tracking-[0.18em] text-white/70 hover:text-gold transition-colors duration-300"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid="header-book-cta"
            className="hidden sm:inline-flex items-center px-6 py-2.5 text-[12px] uppercase tracking-[0.2em] border border-gold/60 text-gold rounded-sm hover:bg-gold hover:text-black transition-all duration-500"
          >
            Book Teresa
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden text-gold p-2"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-black/95 border-t border-gold/15"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="text-sm uppercase tracking-[0.2em] text-white/80"
                >
                  {n.label}
                </a>
              ))}
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex justify-center px-6 py-3 text-xs uppercase tracking-[0.2em] border border-gold/60 text-gold rounded-sm"
              >
                Book Teresa
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
